export const TRANSLATIONS_ES_HOME_QUEUE_AND_ACTIVITY = {
  "home.actionItems.eyebrow": "Acciones pendientes",
  "home.actionItems.title": "Acciones recomendadas",
  "home.actionItems.connection": "Sugerencias de la IA para mantener la cola al día.",
  "home.actionItems.empty": "No hay acciones pendientes.",
  "home.actionItems.unknownDocument": "Documento sin referencia",
  "home.actionItems.due": "Vence",
  "home.smartQueue.eyebrow": "Pendientes prioritarios",
  "home.smartQueue.title": "Documentos que requieren tu revisión",
  "home.smartQueue.totalLabel": "pendientes",
  "home.smartQueue.description": "Priorizamos por riesgo, responsable y estado de cada documento.",
  "home.smartQueue.connection": "Se alimenta de las fechas críticas y las últimas clasificaciones.",
  "home.smartQueue.metricsTitle": "Métricas operativas (opcional)",
  "home.smartQueue.previewTitle": "Lo más prioritario",
  "home.smartQueue.previewSubtitle": "primeros 5",
  "home.smartQueue.previewAction": "Ver",
  "home.smartQueue.previewFilterRole": "Filtrar por rol",
  "home.smartQueue.previewViewAll": "Ver todo",
  "home.smartQueue.status.needsReview": "Necesitan tu revisión",
  "home.smartQueue.status.processing": "En procesamiento automatizado",
  "home.smartQueue.status.ready": "Listos para publicar",
  "home.smartQueue.statusHelper.needsReview": "Requieren aprobación humana para avanzar.",
  "home.smartQueue.statusHelper.processing": "La IA sigue extrayendo y clasificando.",
  "home.smartQueue.statusHelper.ready": "Pueden pasar a publicación o consulta.",
  "home.smartQueue.cta": "Ver pendientes",
  "home.smartQueue.tooltip": "Abre el detalle con todos los documentos priorizados.",
  "home.smartQueue.clearFilter": "Limpiar filtro por estado",
  "home.smartQueue.panelEyebrow": "Detalle de priorización",
  "home.smartQueue.panelTitle": "Documentos agrupados por la IA",
  "home.smartQueue.panelSubtitle": "Desglosados por estado y rol disparador.",
  "home.smartQueue.closePanel": "Cerrar panel de pendientes",
  "home.smartQueue.badgeRole": "Activado por rol",
  "home.smartQueue.badgeDate": "Activado por fecha",
  "home.smartQueue.filterActive": "Filtro aplicado por rol o estado.",
  "home.smartQueue.actions.snooze": "Posponer 24h",
  "home.smartQueue.actions.done": "Marcar hecho",
  "home.smartQueue.actions.assign": "Asignarme",
  "home.smartQueue.markAsDone": "Marcar como Hecho",
  "home.smartQueue.snooze": "Posponer",
  "home.smartQueue.recommendedAction": "Acción Recomendada",
  "home.smartQueue.mutation.snoozeSuccess": "Elemento pospuesto 24h.",
  "home.smartQueue.mutation.doneSuccess": "Elemento marcado como hecho.",
  "home.smartQueue.mutation.assignSuccess": "Elemento asignado a ti.",
  "home.smartQueue.mutation.reclassifySuccess": "Documento reclasificado exitosamente.",
  "home.smartQueue.reclassifyTooltip": "Re-analizar con IA",
  "home.smartQueue.reclassifyModal.title": "Reclasificar Documento",
  "home.smartQueue.reclassifyModal.reasonLabel": "Razón (requerida)",
  "home.smartQueue.reclassifyModal.reasonPlaceholder": "Ej: Documento clasificado incorrectamente como contrato",
  "home.smartQueue.reclassifyModal.correctedTypeLabel": "Tipo de clasificación correcto (requerido)",
  "home.smartQueue.reclassifyModal.correctedTypePlaceholder": "Seleccione el tipo correcto...",
  "home.smartQueue.reclassifyModal.originalTypeHint": "Tipo actual",
  "home.smartQueue.reclassifyModal.notesLabel": "Notas adicionales (opcional)",
  "home.smartQueue.reclassifyModal.notesPlaceholder": "Información adicional sobre la reclasificación...",
  "home.smartQueue.reclassifyModal.confirm": "Reclasificar",
  "home.smartQueue.reclassifyModal.cancel": "Cancelar",
  "home.smartQueue.reviewDocument": "Revisar Documento",
  "home.smartQueue.openDocument": "Abrir documento",
  "home.smartQueue.executeAction": "Ejecutar acción",
  "home.smartQueue.mutation.actionSuccess": "Acción ejecutada exitosamente.",
  "home.smartQueue.panelEmpty": "No hay documentos pendientes.",
  "home.smartQueue.empty": "No hay pendientes. Estás al día.",
  "home.nextAction.eyebrow": "Siguiente paso recomendado",
  "home.nextAction.title": "Siguiente acción",
  "home.nextAction.connection": "Basado en lo detectado hoy.",
  "home.nextAction.reason.pending_review": "Hay documentos que esperan tu aprobación.",
  "home.nextAction.reason.new_documents": "Nuevos documentos listos para ingresar.",
  "home.nextAction.reason.ready_to_query": "Todo está listo para que consultes a la IA.",
  "home.nextAction.reason.due_soon": "Un vencimiento se aproxima.",
  "home.nextAction.reason.overdue": "Un documento quedó vencido.",
  "home.nextAction.reason.high_priority": "Hay un documento con prioridad alta.",
  "home.nextAction.reason.compliance_required": "Se requiere una acción de cumplimiento.",
  "home.nextAction.tooltipLabel": "Explicación de esta sugerencia",
  "home.nextAction.tooltip.queue": "Generada con las fechas detectadas y tus pendientes.",
  "home.nextAction.ack": "Reconocer",
  "home.nextAction.cta": "Ver",
  "home.nextAction.openDocument": "Abrir documento",
  "home.nextAction.ackSuccess": "Acción confirmada.",
  "home.nextAction.empty": "Todo en calma. No hay nada que requiera tu atención ahora.",
  "home.nextAction.action.review": "Revisar",
  "home.nextAction.action.upload": "Subir",
  "home.nextAction.action.chat": "Consultar",
  "home.nextAction.reason.needs_review": "Hay documentos que esperan tu aprobación.",
  "home.lastActivity.eyebrow": "Actividad relevante",
  "home.lastActivity.title": "Cambios recientes en decisiones",
  "home.lastActivity.connection": "Mostramos solo cambios que afectan una decisión o ayudan a explicarla.",
  "home.lastActivity.previewTitle": "Lo que cambió",
  "home.lastActivity.previewSubtitle": "más reciente",
  "home.lastActivity.previewAction": "Revisar",
  "home.lastActivity.markAllRead": "Marcar todo como leído",
  "home.lastActivity.type.classification": "Clasificación",
  "home.lastActivity.type.ingestion": "Ingestión",
  "home.lastActivity.type.extraction": "Extracción",
  "home.lastActivity.type.normalization": "Normalización",
  "home.lastActivity.type.validation": "Validación",
  "home.lastActivity.tooltip": "Haz clic para ver el impacto en prioridades.",
  "home.lastActivity.documentsImpacted": "Documentos relacionados",
  "home.lastActivity.queueImpacted": "Impacto en decisiones",
  "home.lastActivity.navigateQueue": "Ver ítems afectados",
  "home.lastActivity.historyLink": "Ver historial",
  "home.lastActivity.historyEyebrow": "Registro relevante",
  "home.lastActivity.historyTitle": "Historial de actividad",
  "home.lastActivity.closeHistory": "Cerrar historial",
  "home.lastActivity.openPanel": "Ver actividad relevante",
  "home.lastActivity.closePanel": "Cerrar actividad relevante",
  "home.lastActivity.historyEmpty": "No hay eventos registrados.",
  "home.lastActivity.empty": "No hay actividad reciente.",
  "home.lastActivity.supportSignal": "Señal de soporte",
  "home.lastActivity.event.decisionUpdated": "Decisión actualizada",
  "home.lastActivity.event.missingInformationDetected": "Información faltante detectada",
  "home.lastActivity.event.priorityRecalculated": "Prioridad recalculada",
  "home.lastActivity.event.evidenceAdded": "Evidencia agregada",
  "home.lastActivity.event.stateChanged": "Estado cambiado",
  "home.lastActivity.event.actionExecuted": "Acción ejecutada",
  "home.lastActivity.event.supportSignal": "Actualización de soporte",
  "home.lastActivity.event.decisionUpdatedCopy": "La decisión recibió un cambio reciente y conviene revisarla.",
  "home.lastActivity.event.missingInformationDetectedCopy": "Se detectó un dato faltante que puede bloquear la siguiente acción.",
  "home.lastActivity.event.priorityRecalculatedCopy": "La prioridad cambió y puede requerir una revisión más rápida.",
  "home.lastActivity.event.evidenceAddedCopy": "Entró nueva evidencia y la recomendación se volvió a evaluar.",
  "home.lastActivity.event.stateChangedCopy": "La decisión cambió de estado después de una validación reciente.",
  "home.lastActivity.event.actionExecutedCopy": "La acción se registró y la decisión debería reflejar un nuevo estado.",
  "home.lastActivity.event.supportSignalCopy": "Se registró una señal de soporte sin impacto directo en una decisión visible.",
  "home.nextBestDecision.eyebrow": "Decisión protagonista",
  "home.nextBestDecision.title": "Próxima mejor decisión",
  "home.nextBestDecision.viewDecision": "Ver detalle",
  "home.nextBestDecision.owner": "Responsable",
  "home.nextBestDecision.dueAt": "Vence",
  "home.nextBestDecision.nextAction": "Siguiente acción",
  "home.nextBestDecision.priority": "Prioridad",
  "home.nextBestDecision.priorityUnspecified": "Sin tier",
  "home.nextBestDecision.risk": "Riesgo",
  "home.nextBestDecision.notAvailable": "Sin dato",
  "home.nextBestDecision.confidence": "Confianza",
  "home.nextBestDecision.functionalStatus": "Recomendación principal",
  "home.nextBestDecision.recommendationCopy": "Home IA destaca la mejor recomendación de negocio para este caso. Usa las acciones operativas del detalle para asignar, posponer, completar, descartar o reevaluar.",
  "home.nextBestDecision.urgency.critical": "Alta urgencia",
  "home.nextBestDecision.urgency.high": "Importa pronto",
  "home.nextBestDecision.urgency.medium": "Seguimiento cercano",
  "home.nextBestDecision.urgency.low": "Baja urgencia",
  "home.nextBestDecision.allClear.title": "Todo al día",
  "home.nextBestDecision.allClear.subtitle": "No hay decisiones que requieran tu atención ahora mismo. Aprovecha para revisar lo que viene.",
  "home.nextBestDecision.allClear.navLabel": "Accesos rápidos",
  "home.nextBestDecision.allClear.reviewExpirations": "Revisar vencimientos",
  "home.nextBestDecision.allClear.viewChanges": "Ver cambios recientes",
  "home.nextBestDecision.allClear.viewAlerts": "Ver alertas",
  "home.entityActions.toggle": "Acciones de la entidad",
  "home.entityActions.questionsTitle": "Preguntas sugeridas",
  "home.entityActions.questionsError": "No se pudieron cargar las preguntas.",
  "home.entityActions.questionsEmpty": "No hay preguntas sugeridas para esta entidad.",
  "home.entityActions.askAboutEntity": "Preguntar sobre esta entidad",
  "home.entityActions.askPrefill": "Cuéntame sobre",
  "home.entityActions.generate": "Generar documento",
  "home.entityActions.sourcesTitle": "Estas fuentes se usarán",
  "home.entityActions.sourcesError": "No se pudieron cargar las fuentes.",
  "home.entityActions.sourcesEmpty": "No hay fuentes visibles para generar.",
  "home.entityActions.sourcesConfirm": "Generar con estas fuentes",
  "home.entityActions.cancel": "Cancelar",
  "home.entityActions.version": "versión",
  "home.recentChanges.title": "Cambios recientes",
  "home.recentChanges.viewAll": "Ver todos",
  "home.recentChanges.empty": "No hay cambios recientes relevantes en tus documentos.",
  "home.recentChanges.errorTitle": "No se pudieron cargar los cambios",
  "home.recentChanges.errorMessage": "Inténtalo de nuevo en unos segundos.",
};
